/* New arrivals cards: hovering (or focusing) a small product card shows that product's photo big on the card; leaving puts the lifestyle photo back.
   Touch screens have no hover, so a tap simply opens the product. */
(function () {
  'use strict';

  var cards = document.querySelectorAll('.acards__card');
  if (!cards.length) return;

  Array.prototype.forEach.call(cards, function (card) {
    var swap = card.querySelector('[data-acards-swap]');
    var list = card.querySelector('.acards__thumbs');
    if (!swap || !list) return;
    var thumbs = list.querySelectorAll('a[data-full]');
    var preloaded = false;

    function preload() {
      if (preloaded) return;
      preloaded = true;
      Array.prototype.forEach.call(thumbs, function (a) {
        var u = a.getAttribute('data-full');
        if (u) { var im = new Image(); im.src = u; }
      });
    }

    function show(a) {
      var u = a.getAttribute('data-full');
      if (!u) return;
      preload();
      if (swap.getAttribute('src') !== u) swap.setAttribute('src', u);
      swap.classList.add('is-on');
    }
    function hide() { swap.classList.remove('is-on'); }

    Array.prototype.forEach.call(thumbs, function (a) {
      a.addEventListener('mouseenter', function () { show(a); });
      a.addEventListener('focus', function () { show(a); });
      a.addEventListener('blur', hide);
    });
    list.addEventListener('mouseleave', hide);
  });
})();
